import Vue from 'vue';
import Template from '../components/pages/signIn/sp/Index_addMembershipAppeal.vue';

import { reloadOnPageShow } from '../helper/_initHelper';

reloadOnPageShow();

const app = new Vue({
  render: (h) => h(Template, {}),
});
Vue.prototype.$isSp = true;
app.$mount('#app');
